import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const CharCount = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.C};
  margin-top: 6px;
`
